const LOGIN_ROUTE = "/login";
const SIGNIN_ROUTE = "/signin";
const SIGNUP_ROUTE = "/signup";
const FORGOT_PASSWORD_ROUTE = "/forgot";
const RESET_PASSWORD_ROUTE = "/reset-password";
const VERIFY_EMAIL_ROUTE = "/verify-email";


const NEW_ONBOARDING_ROUTES = {
    SIGNUP: SIGNUP_ROUTE,
    LOGIN: LOGIN_ROUTE,
    SIGNIN: SIGNIN_ROUTE,
    FORGOT_PASSWORD: FORGOT_PASSWORD_ROUTE,
    RESET_PASSWORD: RESET_PASSWORD_ROUTE,
    VERIFY_EMAIL: VERIFY_EMAIL_ROUTE,
}

export { LOGIN_ROUTE, SIGNIN_ROUTE, SIGNUP_ROUTE, FORGOT_PASSWORD_ROUTE, VERIFY_EMAIL_ROUTE, NEW_ONBOARDING_ROUTES };
